import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-user-lookup',
  templateUrl: './micro-user-lookup.component.html'
})
export class MicroUserLookupComponent  {

  @Input()
  userId:any;

  @Input()
  link:boolean = true;
}
